import { gsap } from 'gsap';

export default class Animation {
    constructor() {
        this.init();
    }

    init() {
        this._mainvisualAnm();
    }

    _mainvisualAnm() {
        const tl = gsap.timeline();

        tl.set('.mainvisual__catch span', { height: '0%' });
        tl.set('.mainvisual__quopay', { opacity: 0 });
        tl.set('.mainvisual__ttl__txt img', { y: '100%' });

        tl.staggerTo('.mainvisual__ttl__txt img', 0.5, { y: 0, ease: 'circ.out' }, 0.05, 1.0);
        tl.to('.mainvisual__catch.-txt01 span', { duration: 0.8, height: '100%', ease: 'circ.inOut' }, 1.5);
        tl.to('.mainvisual__catch.-txt02 span', { duration: 0.8, height: '100%', ease: 'circ.inOut' }, 1.7);
        tl.to('.mainvisual__catch.-txt03 span', { duration: 0.8, height: '100%', ease: 'circ.inOut' }, 1.9);
        tl.to('.mainvisual__quopay', { duration: 0.8, opacity: 1 }, 1.9);
    }
}
